import { defineMessages } from "react-intl";

import { DealsGroupByType } from "@app/scene/home/enum/DealsGroupByType";
import { DisplayType } from "@app/scene/home/enum/DisplayType";

export const generalMessages = defineMessages({
  title: {
    id: "home.cards.dealsRotting.title",
    defaultMessage: "Rotting Deals",
    description: "Rotting Deals Card Title",
  },
});

export const groupByMessages = defineMessages<DealsGroupByType>({
  [DealsGroupByType.FUNNEL]: {
    id: "home.cards.dealsRotting.menu.groupBy.funnels",
    defaultMessage: "Select funnels",
    description: "Deals Rotting Card menu group by Funnels",
  },
  [DealsGroupByType.TEAM]: {
    id: "home.cards.dealsRotting.menu.groupBy.teams",
    defaultMessage: "Select teams",
    description: "Deals Rotting Card menu group by Teams",
  },
  [DealsGroupByType.USER]: {
    id: "home.cards.dealsRotting.menu.groupBy.users",
    defaultMessage: "Select users",
    description: "Deals Rotting Card menu group by Users",
  },
});

export const displayTypeMessages = defineMessages<DisplayType>({
  [DisplayType.GROSS]: {
    id: "home.cards.dealsRotting.menu.displayType.gross",
    defaultMessage: "Switch to %",
    description: "Engagement Card menu DisplayType item switch to Gross",
  },
  [DisplayType.PERCENT]: {
    id: "home.cards.dealsRotting.menu.displayType.percent",
    defaultMessage: "Switch to gross number",
    description: "Engagement Card menu DisplayType item switch to Percent",
  },
});
